import { formatISO } from 'src/utils/dateOperations/date-fns';
export default function dateToISODateTime(date) {
    var _a;
    const result = (_a = formatISO(date, { representation: 'complete' })) === null || _a === void 0 ? void 0 : _a.substring(0, 16);
    return result;
}
